import { useMenuSelectors } from "../../../../../../app/state/menuSlice/hook/use-menu-selectors";
import { TMenuIds } from "../../../../../../app/state/menuSlice/types";
import { UploadFileButton } from "../../../../../../common/Components/Buttons/UploadFileButton";
import { MenuBasic } from "../../../../../../common/Components/Menu/MenuBasic";
import { AppMenuItem } from "../../../../../../shared/components/AppMenu/AppMenuItem";
import { useAttachedHtmlMenu } from "../../../../hook/use-attached-html-menu";
import styles from "./styles.module.css";

interface Props {
  closeMenu: (id: TMenuIds) => void;
  className?: string;
}

export const AttachedHtmlToSpaMenu = ({ closeMenu }: Props) => {
  const attachedHtmlMenu = useMenuSelectors("attached_html_to_spa");
  const { handleFileUpload, handleChangeHtml } = useAttachedHtmlMenu();

  return (
    <MenuBasic
      isOpen={attachedHtmlMenu.isOpen}
      position={attachedHtmlMenu.position}
      onClose={() => closeMenu("attached_html_to_spa")}
      verticalPos={35}
      leftPos={0}
    >
      <AppMenuItem
        onClick={() => {
          handleChangeHtml();
          closeMenu("attached_html_to_spa");
        }}
        className={styles["menu-item"]}
      >
        Загрузить из буфера обмена
      </AppMenuItem>
      <AppMenuItem className={styles["menu-item"]}>
        <UploadFileButton
          title={"Загрузить из компьютера"}
          handleFileUpload={(e) => {
            handleFileUpload(e);
            closeMenu("attached_html_to_spa");
          }}
          type={"button"}
          icon={null}
          className={styles["upload-btn"]}
        />
      </AppMenuItem>
    </MenuBasic>
  );
};
